<div class="payment-barclays-container">
  <!-- Loading state -->
  @if (isLoading) {
    <div class="loading-spinner" id="loading-spinner">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading payment form...</p>
    </div>
  }

  <!-- Processing payment state -->
  @if (isProcessingPayment) {
    <div class="loading-spinner" id="processing-payment-spinner">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Processing payment...</p>
    </div>
  }

  <!-- Payment form container (SDK will render here) -->
  @if (!isLoading && !isProcessingPayment) {
    <div class="payment-form-wrapper" id="payment-form-wrapper">
      <!-- Order Summary -->
      <div class="order-summary" id="order-summary">
        <h2 class="summary-title" id="summary-title">{{ appInfoService.appStrings.paymentDetails_info }}</h2>
        <div class="summary-row">
          <span class="label" id="quote-number-label">{{ appInfoService.appStrings.quote_quoteNumber }}</span>
          <span class="value" id="quote-number-value">{{ quoteNumber }}</span>
        </div>
        <div class="summary-row">
          <span class="label" id="subtotal-label">{{ appInfoService.appStrings.barclays_subtotal }}</span>
          <span class="value" id="subtotal-value">{{ paymentSummary?.subTotal | currency: currencySymbol }}</span>
        </div>
        @if (paymentSummary?.tax) {
          <div class="summary-row">
            <span class="label" id="tax-label">{{ appInfoService.appStrings.barclays_tax }}</span>
            <span class="value" id="tax-value">{{ paymentSummary.tax | currency: currencySymbol }}</span>
          </div>
        }
        @if (paymentSummary?.freightCost) {
          <div class="summary-row">
            <span class="label" id="freight-label">{{ appInfoService.appStrings.barclays_freight }}</span>
            <span class="value" id="freight-value">{{ paymentSummary.freightCost | currency: currencySymbol }}</span>
          </div>
        }
        <hr class="divider">
        <div class="summary-row total">
          <span class="label" id="grand-total-label">{{ appInfoService.appStrings.paymentDetails_summary_grand_total }}</span>
          <span class="value" id="grand-total-value">{{ paymentSummary?.grandTotal | currency: currencySymbol }}</span>
        </div>
      </div>
      <!-- Embedded Payment Screen - SDK will inject here -->
      <div id="embeddedPaymentContainer" #embeddedPaymentContainer></div>
    </div>
  }
</div>
